export default {
  arrangementTime: '安排时间',
  tabEnd: '结束',
  tabVideo: '视频',
  tabPaper: '试题',
  tabPaperDraw: '抽题',
  tabConference: '进入会议',
  videoStatus: {
    notStart: '未开始',
    connect: '可连接',
    interviewing: '视频中',
    hangup: '已挂断',
    ended: '已结束',
    checkIn: '已登录',
    online: '在线',
    offline: '离线',
  },
  // conferenceTips: "会议尚未开始",
  conferenceTips: '会议已结束',
  joinConferenceFailedTips: '加入会议失败',
  fraud: '舞弊',
  fraudCancel: '取消舞弊标记',
  absent: '弃考',
  absentCancel: '取消弃考标记',
  exempt: '免测',
  exemptCancel: '取消免测标记',
  groupName: '所属组',
  groupNumber: '编号',
  number: '{number}号',
  view: '查看',
  showHistory: '查看历史成绩',
  logout: '退出登录',
  interviewStatus: {
    complete: '已结束',
    interviewing: '进行中',
    waiting: '未开始',
  },
  candidateStatus: {
    label: '考生端状态',
    options: {
      not_checked_in: '未签到',
      checked_in: '已签到',
      preparing: '备考中',
      waiting_video: '等待视频',
      waiting_interview: '待开面试',
      interviewing: '面试中',
      interview_finished: '面试结束',
    },
  },
  refresh: '刷新',
  refreshSuccess: '刷新成功',
  average: '该候选人平均成绩',
  score: '分',
  tipStatus: {
    interviewing: '评分进行中',
    processing: '修改成绩申请中',
    unconfirmed: '管理员已拒绝修改成绩申请',
    confirmed: '管理员已同意修改成绩申请',
    unsubmitted: '评分调整中',
  },
  examScore: '考试成绩',
  viewPaper: '查看答卷',
  fullScore: '满分',
  minScore: '最低分',
  halfScore: '半分',
  pointLabel: '打分',
  pointPlaceholder: '请打分',
  comment: '评语',
  totalScore: '总得分',
  originalScore: '原始得分',
  historyScore: '历史成绩',
  imagePreview: '图片预览',
  ruleForm: {
    editReasonLabel: '修改原因',
    editReasonPlaceholder: '请输入修改原因',
    oldScoreLabel: '原评分',
    oldScorePlaceholder: '请输入原评分',
    newScoreLabel: '修改后的评分',
    newScorePlaceholder: '请输入修改后的评分',
    isMasterConfirm: '裁判组长是否已同意',
    yes: '是',
    no: '否',
    confirm: '确 定',
    cancel: '取 消',
    modifyContent: '修改内容',
    oldTotalScore: '原总分',
    newTotalScore: '修改后总分',
    cancelApplication: '撤销申请',
    cancelApplicationTitle: '撤销申请',
    cancelApplicationConfirm: '确定要撤销本次修改成绩申请吗？',
  },
  checkInTip: '该候选人尚未签到，请先给该候选人签到。',
  checkInButton: '签到',
  noDataMsg: '暂无评分表',
  placeholder: {
    reason: '请输入修改原因',
    old_score: '请输入原评分',
    new_score: '请输入修改后的评分',
  },
  fraudConfirmMsg: '标记舞弊后，候选人将不能被评分，成绩作废，确定标记？',
  fraudCancelMsg: '确认取消该候选人的舞弊标记？',
  absentConfirmMsg: '标记弃考后，候选人将不能被评分，成绩作废，确认标记？',
  absentCancelMsg: '确认取消该候选人的弃考标记？',
  exemptConfirmMsg: '标记免测后，候选人将不能被评分，确认标记？',
  exemptDeleteWarning: '如已开始评分，将会删除评分记录，且无法恢复！',
  exemptCancelMsg: '确认取消该候选人的免测标记？',
  signOutConfirmMsg: '确定退出面试评分系统？',
  signOutCancelMsg: '取消退出',
  modifyScoreConfirmMsg: '确认需要修改成绩吗？',
  modifyScoreConfirmButton: '修改成绩',
  interviewingAlertMsg: '当前选手暂未打分',
  scoreMsg: ['当前候选人的分数是', '结果', '您确定提交吗?'],
  scoreAlertMsg: '评分项“{msg}”未判分，请在所有评分项判分后提交面试结果',
  signTips: '此次修改成绩后需要在列表上重新进行场次的签字，确认修改？',
  error307: '您已被管理员结束打分，点击确定后，将跳转到首页',
  error401: '登录过期，请重新登录',
  successMsg: {
    processing: '修改成绩申请中，请耐心等待',
    confirmed: '管理员已同意修改成绩申请',
    unconfirmed: '管理员已拒绝修改成绩申请',
    // default: '出了一些问题',
  },
  applicationNotify: '申请状态提示',
  applicationRecords: '申请记录',
  recordColumns: {
    applyTime: '申请时间',
    oldScore: '原得分',
    newScore: '修改为',
    status: '审核状态',
  },
  recordStatus: {
    processing: '审核中',
    confirmed: '已通过',
    confirmed_done: '已通过',
    cancelled: '已撤销',
    unconfirmed: '已拒绝',
    unconfirmed_done: '已拒绝',
  },
  showHistoryNoData: '此候选人暂无历史成绩',
  videoOpreateStartAlert: '面试时间未到，请稍后...',
  videoOpreateEndAlert: '面试已结束，如有需要请联系管理员',
  noPaper: '暂无试题',
  noPaperAlert: {
    title: '提示',
    msg: '当前无有效试题！',
    expired: '原内容已失效，本次将打开新的内容，新内容有效时间为：',
  },
  paperExpireAlert: {
    title: '该试题还有{time}分钟过期。',
    confirm: '继续播放',
    cancel: '取消播放',
    confirmPaper: '继续操作',
    cancelPaper: '取消操作',
  },
  btnContent: {
    unsubmitted: '完成',
    waiting: '开始评分',
    interviewing: '完成',
    complete: '修改成绩',
    processing: '查看申请状态',
    confirmed: '修改成绩',
    unconfirmed: '修改成绩',
  },
  showPaperNoData: '尚无数据，请在考生开考后重试。',
  personalInfo: {
    姓名: '姓名',
    性别: '性别',
    客户编号: '客户编号',
    身份证号: '身份证号',
    邮箱地址: '邮箱地址',
    手机号码: '手机号码',
    预约时间: '预约时间',
    应聘岗位: '应聘岗位',
    毕业学校: '毕业学校',
    所在地区: '所在地区',
    照片: '照片',
    简历: '简历',
    报告: '报告',
    签到开始时间: '签到开始时间',
    签到截至时间: '签到截至时间',
    候考区: '候考区',
    面试室: '面试室',
  },
  exceedMaximumScore: '评分分值不符合预设分值。',
  period: '。',
  exitConfirm: '退出当前视频会议？',
  minScoreMsg: ['当前总得分低于最小分值', '须填写评语。'],
  maxScoreMsg: ['当前总得分高于最大分值', '须填写评语。'],
  groupScore: '集体评分',
  singleScore: '单人评分',
  confirmDrawPaperMsg: '确定后，将为本组候选人抽取面试题。',
  drawingPaper: '系统正在抽题，请稍后……',
  drawPaperDone: '抽题完成，请查看试题。',
  drawPaperConfirmText: '查看试题',
  drawPaperCancelText: '关闭',
  moreInfo: '更多信息',
  collapseInfo: '收起',
  noFile: '暂无文件',
  networkError: '评分失败！网络异常，请检查网络情况后重试。',
};
